"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawableDeleteBinding = drawableDeleteBinding;
function drawableDeleteBinding(dc, evt) {
    var drawable = dc.drawState.getDrawable(evt.drawableId);
    if (drawable == null) {
        return;
    }
    if (evt.$event != null) {
        evt.$event.preventDefault();
    }
    if (!drawable.isDeletable) {
        return;
    }
    if (dc.state.selectedId === evt.drawableId) {
        dc.state.setSelected(null, null);
    }
    if (dc.state.hoverId === evt.drawableId) {
        dc.state.setHovered(null);
    }
    drawable.remove();
}
//# sourceMappingURL=drawable.delete.binding.js.map